import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import * as actions from 'global/actions/authActions';
import CurvedContainer from 'components/CurvedContainer/CurvedContainer';
import { colors } from 'global/colors';
import { AUTH_TWO_FACTOR_TIMEOUT_ERROR } from 'global/constants';
import { Button } from 'components/Button/RoundButton';
import { Input, InfoText, Form } from 'components/FormComponents/FormComponents';
import { Container, Wrapper, Header } from 'components/Layout/Layout';
import { Link, BottomContainer } from './styles';
import { useActions } from 'hooks/useActions';
import { Images } from 'assets/images';
import { useAppContext } from 'hooks/useContext';
import * as strings from './strings';
import Path from 'routes/Path';
import apiErrors from 'api/apiErrors';

export default React.memo(() => {
  const { authLoading, authError, authTwoFactor } = useSelector((state) => state.auth);
  const { clearAuthError, login, loginTwoFactor } = useActions(actions);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [twoFactorCode, setTwoFactorCode] = useState('');
  const { language } = useAppContext();

  return (
    <Wrapper>
      <CurvedContainer bottom image={Images.art} height={110} />
      <Container color={colors.lightGray} half column>
        <Header>{strings.header[language]}</Header>
        {!authTwoFactor && (
          <>
            <Form onChange={() => authError && clearAuthError()} onSubmit={() => login(email, password)}>
              <Input
                autoFocus
                type="email"
                name="email"
                autoComplete="email"
                value={email}
                placeholder={strings.emailPlaceholder[language]}
                onChange={(e) => setEmail(e.target.value)}
              />
              <Input
                type="password"
                value={password}
                placeholder={strings.passwordPlaceholder[language]}
                onChange={(e) => setPassword(e.target.value)}
              />
              <Button
                primary
                type="submit"
                disabled={!email || !password || (authError && authError !== AUTH_TWO_FACTOR_TIMEOUT_ERROR)}
              >
                {strings.header[language]}
              </Button>
            </Form>
          </>
        )}
        {authTwoFactor && (
          <>
            <Form onChange={() => authError && clearAuthError()} onSubmit={() => loginTwoFactor(twoFactorCode)}>
              <Input
                autoFocus
                type="numeric"
                value={twoFactorCode}
                placeholder={strings.twoFaPlaceholder[language]}
                onChange={(e) => setTwoFactorCode(e.target.value)}
              />
              <Button primary type="submit" disabled={!twoFactorCode || authError}>
                {strings.header[language]}
              </Button>
            </Form>
          </>
        )}
        <BottomContainer>
          <InfoText error={authError}>
            {authLoading ? strings.loadingLabel[language] : ''}
            {apiErrors?.[authError?.name]?.[language] ?? authError}
          </InfoText>
          <Link to={Path.signupPage}>{strings.signupLabel[language]}</Link>
          <Link to={Path.resetPasswordPage}>{strings.resetPassword[language]}</Link>
        </BottomContainer>
      </Container>
    </Wrapper>
  );
});
